import {useEffect} from 'react'
function usePageTitle(value) {
  const displayName = localStorage.getItem('displayName')
  useEffect(() => {
    document.title = `${value} - ${displayName} | Powered by Zylk HRMS`
  }, [value, displayName])
}
export default usePageTitle
